import { useJsApiLoader } from '@react-google-maps/api';
import { useQuery } from 'react-query';

const useGoogleMapsClient = () => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: String(process.env.NX_PUBLIC_GOOGLE_MAPS_API_KEY),
  });

  if (!isLoaded) {
    return null;
  }

  return window.google.maps;
};

export const useGetReverseGeolocation = (coords?: {
  lat: number;
  lng: number;
}) => {
  const client = useGoogleMapsClient();
  return useQuery(
    ['getReverseGeolocation', coords?.lat, coords?.lng],
    () => {
      if (!client || !coords) {
        return;
      }
      const geocoder = new client.Geocoder();
      return geocoder.geocode({
        location: {
          lat: coords.lat,
          lng: coords.lng,
        },
      });
    },
    {
      enabled: Boolean(client) && Boolean(coords),
    }
  );
};
